import type { MasterTemplate } from "hoxton-types";

import type { ConstructedDeliverable, EditedEditable } from "@/types/types";

export function getBannerIdFromDeliverable(deliverable: ConstructedDeliverable, namespace: string) {
    return `${namespace}-iframe-${deliverable.idHash}`;
}

export function getBannerIdFromMasterTemplate(masterTemplate: MasterTemplate, namespace: string) {
    return `${namespace}-iframe-${masterTemplate._id}`;
}

export function getBannerIdFromEditable(editable: EditedEditable, namespace: string) {
    return `${namespace}-iframe-${editable.masterTemplateId}`;
}
